import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navs = [
  { to: '/', label: '首页' },
  { to: '/review', label: '复盘档案' },
  { to: '/event', label: '深度复盘' },
  { to: '/about', label: '关于我们' },
];

export default function Masthead() {
  const [open, setOpen] = useState(false);

  const linkCls = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap text-sm tracking-wide transition-colors hover:text-primary-500 ${
      isActive ? 'text-primary-600 font-semibold' : 'text-foreground-700'
    }`;

  return (
    <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between px-4 md:h-[72px] md:px-6">
        <Link to="/" className="group flex items-center gap-2.5" aria-label="99吃瓜 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-brand text-lg leading-none text-background-50">
            瓜
          </span>
          <span className="font-brand text-2xl leading-none tracking-tight">
            99<span className="text-primary-500">吃瓜</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" aria-label="主导航">
          {navs.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} end={n.to === '/'}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/event"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            看这篇复盘
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-3-line text-2xl'} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col">
            {navs.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-base transition-colors ${
                    isActive ? 'bg-primary-100 font-semibold text-primary-700' : 'text-foreground-800 hover:bg-background-100'
                  }`
                }
              >
                {n.label}
                <i className="ri-arrow-right-s-line text-xl" aria-hidden="true" />
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}